import { IAppState } from '../../../../../AppModulesWrapper';

import { IPaidPublicationState } from '../types';

export const selectPaidPublication = (state: IAppState): IPaidPublicationState => {
  return state.servicePickerWidgetV2.paidPublication;
};
